/**
 *  Arrow
 *
 *  An animated arrow.
 *
 */

import React, { useLayoutEffect, useContext } from "react";
import { ConfigurationContext } from "contexts/ConfigurationContext";
import "./arrow.css";
import $ from "jquery";

const upArrow = "arrowUp"; // CSS class name.
const downArrow = "arrowDown"; // CSS class name.

const leftMargin = 100; // Left side margin for arrow.
const rightMargin = 250; // Right side margin for arrow.
const topMargin = 10; // Top side margin for arrow.
const bottomMargin = 10; // Bottom side margin for arrow.

const startDelay = 2000; // Delay before starting animation.
const bounceInterval = 5000; // Interval between bounces.
const fallHeight = 300; // Height of the initial fall.
const bounceHeight = 40; // Height of each bounce.

/**
 * Bounce the arrow up and then down.
 */

const bounceUpDown = (height) => {
  $("#arrow").animate({ top: `-=${height}px` }, "fast");
  $("#arrow").animate({ top: `+=${height}px` }, "fast");
};

/**
 * Bounce the arrow down and then up.
 */

const bounceDownUp = (height) => {
  $("#arrow").animate({ top: `+=${height}px` }, "fast");
  $("#arrow").animate({ top: `-=${height}px` }, "fast");
};

/**
 * Bounce the arrow.
 *
 * @param {string} orientation up or down
 */

const bounceArrow = (orientation) => {
  orientation === upArrow
    ? bounceDownUp(bounceHeight)
    : bounceUpDown(bounceHeight);
  orientation === upArrow
    ? bounceDownUp(bounceHeight / 4)
    : bounceUpDown(bounceHeight / 4);
};

const getLeft = () => {
  return leftMargin;
};
const getRight = () => {
  return $(window).width() - rightMargin;
};
const getTop = () => {
  return /*$(window).scrollTop() + */ topMargin;
};
const getBottom = () => {
  return (
    /*$(window).scrollTop() + */ $(window).height() -
    $("#arrow").height() -
    bottomMargin
  );
};

/**
 * Calculate the arrow positioning from the browser and os types.
 *
 * @param {*} configuration The app configuration containing browser and os type.
 */

// TODO: Add mac safari and other mac browsers.

const calculatePositioning = (configuration) => {
  if (
    configuration.os === "windows" &&
    (configuration.browser === "chrome" || configuration.browser === "edge")
  ) {
    //console.log("this one");
    // Windows with Chrome, or Edge.
    return {
      startX: getLeft(),
      startY: getBottom() - fallHeight,
      endX: getLeft(),
      endY: getBottom(),
      orientation: downArrow,
    };
  } else if (
    configuration.os === "windows" &&
    configuration.browser === "firefox"
  ) {
    // Windows with Firefox.
    return {
      startX: getRight(),
      startY: getTop() + fallHeight,
      endX: getRight(),
      endY: getTop(),
      orientation: upArrow,
    };
  } else {
    // Default catch-all
    // TODO: Make this not display.
    return {
      startX: getLeft(),
      startY: getBottom() - fallHeight,
      endX: getLeft(),
      endY: getBottom(),
      orientation: downArrow,
    };
  }
};

/**
 * Determine if the arrow should render based on browser type.
 *
 */
const canRender = (configuration) => {
  return (
    configuration.browser.includes("firefox") ||
    // configuration.browser.includes("chrome") ||
    configuration.browser.includes("safari") ||
    configuration.browser.includes("ie") //||
    // configuration.browser.includes("edge")
  );
};

/**
 *  Arrow component.
 *
 */
export const Arrow = (props) => {
  let configuration = useContext(ConfigurationContext);

  useLayoutEffect(() => {
    // Start the arrow animation.
    setTimeout(() => {
      if (!canRender(configuration)) {
        // Not rendering so do nothing here.
        return;
      }

      let pos = calculatePositioning(configuration);
      $("#arrow").css({
        top: pos.startY + "px",
        left: pos.startX + "px",
        positioning: "absolute",
      });
      $("#arrow").animate({ opacity: 1.0 }, "fast", () => {
        $("#arrow").animate({ top: pos.endY + "px" }, "slow", () => {
          bounceArrow(pos.orientation);
          setInterval(() => {
            bounceArrow(pos.orientation);
          }, bounceInterval);
        });
      });
    }, startDelay);
  }, []);

  return canRender(configuration) ? (
    <div
      id="arrow"
      className={calculatePositioning(configuration).orientation}
    ></div>
  ) : null;
};
